import initU2F from '../../shared/sessions/u2f';

document.addEventListener('DOMContentLoaded', initU2F);



// WEBPACK FOOTER //
// ./pages/sessions/index.js